import { useQuery } from '@tanstack/react-query';

import { getProductInformationSettings } from 'apis/offer-listing-service/api';

type Args = {
  selectionId: string;
};

export const useProductInformationSettings = ({ selectionId }: Args) => {
  const { data: productInfoSettings, isLoading: productInfoSettingsLoading } = useQuery(
    ['product-information-settings', selectionId],
    getProductInformationSettings,
    { refetchOnMount: false, refetchOnWindowFocus: false },
  );

  return {
    productInfoSettings,
    productInfoSettingsLoading,
  };
};
